/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Meta_TitleInputs */

const es_ab_meta_title = /** @type {(inputs: Ab_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Añade tu barco — Convierte tu barco en ingresos`)
};

const gl_ab_meta_title = /** @type {(inputs: Ab_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Engade o teu barco — Converte o teu barco en ingresos`)
};

const en_ab_meta_title = /** @type {(inputs: Ab_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar · Add your boat — Turn your boat into income`)
};

/**
* | output |
* | --- |
* | "Zarpar · Add your boat — Turn your boat into income" |
*
* @param {Ab_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_meta_title = /** @type {((inputs?: Ab_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_meta_title(inputs)
	if (locale === "en") return en_ab_meta_title(inputs)
	return es_ab_meta_title(inputs)
});